import React, { createElement, FunctionComponent } from 'react';
import styled, { css } from 'styled-components';

interface ComponentProps extends Component {
  icon: FunctionComponent<SimpleObject>;
  size?: number;
}

const Root = styled(({ className, icon, size }: ComponentProps) => createElement(icon, { className, size }))`
  ${({ size }) => css`
    flex-shrink: 0;
    width: ${(size ? size : 32) / 16}rem;
    min-width: ${(size ? size : 32) / 16}rem;
    height: ${(size ? size : 32) / 16}rem;
  `}
`;

const Icon = ({ icon, className, size }: ComponentProps) => <Root icon={icon} size={size} className={className} />;

export default Icon;
